const SvgIcon = ({ size = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    version="1.1"
    viewBox="0 0 0.333 0.333"
  >
    <g strokeLinecap="round" strokeLinejoin="round">
      <g fillRule="evenodd" color="#000">
        <path
          fill="#fff"
          strokeWidth="0.018"
          d="M.07.184V.05S.065.008.113.008h.114l.098.098v.167c0 .03-.015.039-.068.039S.07.184.07.184"
        ></path>
        <path
          fill="#000"
          d="M.113 0C.086 0 .072.013.066.026S.062.05.062.05v.133L.064.19A1 1 0 0 0 .2.299.1.1 0 0 0 .257.32q.04.001.059-.01A.03.03 0 0 0 .329.296.1.1 0 0 0 .333.274V.106L.331.1.234.002.228 0zm0 .018h.111L.316.11v.164q0 .009-.002.013L.306.295a.1.1 0 0 1-.049.008.1.1 0 0 1-.047-.02A1.863 1.863 0 0 1 .08.181V.05Q.077.047.08.033C.085.026.091.018.113.018"
        ></path>
      </g>
      <g fillRule="evenodd" color="#000">
        <path
          fill="#fff"
          strokeWidth="0.018"
          d="M.218.009v.075c0 .026.03.027.03.027h.076"
        ></path>
        <path
          fill="#000"
          d="M.218 0A.01.01 0 0 0 .21.008v.076c0 .017.01.027.02.031Q.246.121.247.12h.077a.01.01 0 0 0 .01-.007L.33.106.324.102H.247L.237.1Q.229.097.228.084V.008L.227.006.222 0z"
        ></path>
      </g>
      <g fillRule="evenodd" color="#000">
        <path
          fill="#fff"
          strokeWidth="0.018"
          d="M.109.102h.069"
        ></path>
        <path
          fill="#000"
          d="M.107.096a.01.01 0 0 0-.01.008.01.01 0 0 0 .01.01h.068a.01.01 0 0 0 .01-.01L.183.102.179.096H.175z"
        ></path>
      </g>
      <g fillRule="evenodd" color="#000">
        <path
          fill="#fff"
          strokeWidth="0.018"
          d="M.109.13h.069"
        ></path>
        <path
          fill="#000"
          d="M.107.123a.01.01 0 0 0-.01.008.01.01 0 0 0 .01.01h.068a.01.01 0 0 0 .01-.01L.183.129.179.123H.175z"
        ></path>
      </g>
      <path
        fill="#bd1727"
        fillRule="evenodd"
        strokeWidth="0.001"
        d="M.043.164h.191c.024 0 .043.019.043.043V.29c0 .024-.019.043-.043.043h-.19A.043.043 0 0 1 0 .29V.207C0 .183.02.164.043.164"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0.021"
        d="M.073.268Q.103.27.102.232T.072.196H.04V.3h.027V.268zM.076.235q0 .012-.005.011H.067V.223H.07q.006 0 .006.012"
        fontSize="0.146"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0.021"
        d="M.176.246c0-.03-.008-.05-.037-.05H.108V.3h.03C.169.3.177.277.177.246M.15.25Q.15.273.139.274H.134v-.05h.003c.01 0 .01.008.01.025"
        fontSize="0.146"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0.021"
        d="M.235.224.236.196H.184V.3h.027V.262H.23V.238H.211V.224z"
        fontSize="0.146"
      ></path>
    </g>
  </svg>
);

export default SvgIcon;
